import { PrecisionForm } from 'components/userPreferences/form/tabs/PrecisionForm';
import { connect } from 'react-redux';
import { getUserPreferencesPrecisions } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { userPreferencesDisplayPrecisionChanged } from 'state/userPreferences/userPreferences.action';
import type { DisplayPrecisionKeys, DisplayPrecisionValues } from 'state/userPreferences/userPreferences.model';

type StateProps = DisplayPrecisionValues;
type DispatchProps = {
  onPrecisionChanged<K extends DisplayPrecisionKeys>(key: K, value: number): void;
};

export type PrecisionProps = StateProps & DispatchProps;

const mapStateToProps = (state: AppState): StateProps => {
  return getUserPreferencesPrecisions(state)!;
};
function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
  return {
    onPrecisionChanged(key, value) {
      dispatch(userPreferencesDisplayPrecisionChanged(key, value));
    },
  };
}
export const ConnectedPrecisionForm = connect(mapStateToProps, mapDispatchToProps)(PrecisionForm);
